<div class="root row align-center">
  <app-edit-details-card [user]="currentUser" (edit)="handleEdit($event)"></app-edit-details-card>
  <div class="spacer"></div>
  <app-linked-accounts-card [accounts]="accounts"></app-linked-accounts-card>
</div>
